"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Body = exports.Page = exports.default = void 0;

var _SubmissionPage = babelHelpers.interopRequireDefault(require("pages/_SubmissionPage"));

var _MakeSubmissionPage = (0, _SubmissionPage.default)('pages/SubmissionAudioDetail', 'layouts/ObjectDetailNew'),
    Page = _MakeSubmissionPage.Page,
    Body = _MakeSubmissionPage.Body;

exports.Body = Body;
exports.Page = Page;
var _default = Page;
exports.default = _default;